import { authControllerHasCode } from "@/shared/api/generated"
import { ConfirmEmailExpired } from "./confirm-email-expired"
import { ConfirmEmailInputCode } from "./confirm-email-input-code"
import { QUERY_KEYS } from "@/shared/constants"
import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { useUserStore } from "@/entities"
import { UiFullscreenSpinner } from "@/shared/ui"
import styles from "./styles.module.scss"
import { Button } from "@/components/ui/button"
import { ArrowLeftIcon } from "lucide-react"
import { ToggleTheme } from "@/features/toggle-theme"

const ConfirmEmailLayoutHeader = () => {
  const logout = useUserStore(s => s.logout)

  return (
    <header className={styles.header}>
      <div className={styles.header__left}>
        <Button onClick={() => logout()} variant="outline">
          <ArrowLeftIcon size={24} />
        </Button>
      </div>

      <div className={styles.header__right}>
        <div>
          <ToggleTheme />
        </div>
      </div>
    </header>
  )
}

const ConfirmEmailLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <main className={styles.main}>
      <ConfirmEmailLayoutHeader />

      <div className={styles.main__content}>{children}</div>
    </main>
  )
}

export const ConfirmEmailWidget = () => {
  const login = useUserStore(state => state.login)

  const { data, isLoading } = useQuery({
    queryKey: QUERY_KEYS.HAS_CODE,
    queryFn: authControllerHasCode,
    refetchOnWindowFocus: true,
  })

  useEffect(() => {
    if (data && !data.hasNumbers && data.access_token) {
      login(data.access_token)
    }
  }, [data])

  if (isLoading || !data) {
    return (
      <ConfirmEmailLayout>
        <UiFullscreenSpinner />
      </ConfirmEmailLayout>
    )
  }

  if (data.hasNumbers) {
    return (
      <ConfirmEmailLayout>
        <ConfirmEmailInputCode />
      </ConfirmEmailLayout>
    )
  }

  if (!data.hasNumbers && data.access_token) {
    return (
      <ConfirmEmailLayout>
        <UiFullscreenSpinner />
      </ConfirmEmailLayout>
    )
  }

  return (
    <ConfirmEmailLayout>
      <ConfirmEmailExpired />
    </ConfirmEmailLayout>
  )
}
